/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabView, TabPanel } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// @mui material components
import Grid from "@mui/material/Grid";

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";

import RejectedTransaction from "./rejected-transaction";
import Transaction from "./transaction";
import CompletedTransaction from "./completed-transaction";

const cookies = new Cookies();

const TransactionParent = ({
  getSubModulesByRoleIdReducer,
  getSubModulesByRoleId,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : []
    );
  }, [getSubModulesByRoleIdReducer]);

  console.log(modulesData)

  // let transactionModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "4423f4d8-d918-497d-9322-480e21960398"
  // );

 const transactionModule = modulesData.find(
  (module) => 
    module.moduleId === "4423f4d8-d918-497d-9322-480e21960398" &&
    module.actionId?.includes("4f20d4e7-4d64-443e-9acc-70c0b49ddf93")
);
 const rejectedTransactionModule = modulesData.find(
  (module) => 
    module.moduleId === "4423f4d8-d918-497d-9322-480e21960398" &&
    module.actionId?.includes("594702a7-6daf-4042-8e7b-af7b79f1510e")
);
 const completedTransactionModule = modulesData.find(
  (module) => 
    module.moduleId === "4423f4d8-d918-497d-9322-480e21960398" &&
    module.actionId?.includes("acbb34b5-6893-4ae1-972d-2d3c3fc5023c")
);

  // let completedTransactionModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "4423f4d8-d918-497d-9322-480e21960398"
  // );

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {transactionModule &&
            completedTransactionModule &&
            rejectedTransactionModule ? (
              <TabView>
                <TabPanel header="Transaction">
                  <Transaction />
                </TabPanel>
                <TabPanel header="Completed Transaction">
                  <CompletedTransaction />
                </TabPanel>
                <TabPanel header="Rejected Transaction">
                  <RejectedTransaction />
                </TabPanel>
              </TabView>
            ) : !transactionModule &&
              completedTransactionModule &&
              rejectedTransactionModule ? (
              <TabView>
                <TabPanel header="Completed Transaction">
                  <CompletedTransaction />
                </TabPanel>
                <TabPanel header="Rejected Transaction">
                  <RejectedTransaction />
                </TabPanel>
              </TabView>
            ) : transactionModule &&
              !completedTransactionModule &&
              rejectedTransactionModule ? (
              <TabView>
                <TabPanel header="Transaction">
                  <Transaction />
                </TabPanel>
                <TabPanel header="Rejected Transaction">
                  <RejectedTransaction />
                </TabPanel>
              </TabView>
            ) : transactionModule &&
              completedTransactionModule &&
              !rejectedTransactionModule ? (
              <TabView>
                <TabPanel header="Transaction">
                  <Transaction />
                </TabPanel>
                <TabPanel header="Completed Transaction">
                  <CompletedTransaction />
                </TabPanel>
              </TabView>
            ) : transactionModule &&
              !completedTransactionModule &&
              !rejectedTransactionModule ? (
              <TabView>
                <TabPanel header="Transaction">
                  <Transaction />
                </TabPanel>
              </TabView>
            ) : !transactionModule &&
              !completedTransactionModule &&
              rejectedTransactionModule ? (
              <TabView>
                <TabPanel header="Rejected Transaction">
                  <RejectedTransaction />
                </TabPanel>
              </TabView>
            ) : completedTransactionModule &&
              !transactionModule &&
              !rejectedTransactionModule ? (
              <TabView>
                <TabPanel header="Completed Transaction">
                  <CompletedTransaction />
                </TabPanel>
              </TabView>
            ) : !completedTransactionModule &&
              !transactionModule &&
              !rejectedTransactionModule ? (
              <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                No Transaction Access
              </h4>
            ) : null}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(TransactionParent);
